// Check if the user agent contains "Android"
export const isAndroid = /Android/i.test(navigator.userAgent);

// Check if the user agent contains "iPhone" or "iPad" (iOS)
export const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

export const isNotificationPermission =
  'Notification' in window &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  Notification.permission === 'granted';

export const isNotificationDefault =
  'Notification' in window &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  Notification.permission === 'default';

export function loadImage(url: string): Promise<boolean> {
  return new Promise((resolve, reject) => {
    // Create a new Image object
    const image = new Image();

    // Set the image source to the provided URL
    image.src = url;

    // When the image is successfully loaded, update the image element's source
    image.onload = () => {
      resolve(true);
    };

    // If there is an error loading the image, reject the Promise
    image.onerror = (error) => {
      console.error(`Error loading image from ${url}:`, error);
      reject();
    };
  });
}
